import mixpanel from 'mixpanel-browser';
import { ID } from 'shared/types/id';

import { ActionEvents } from '../models/action-events';
import { EventProps } from '../models/event-props';
import { PageEvents } from '../models/page-events';
import { SuperProperties, UserProperties } from '../models/super-properties';

const pageEvents = Object.values(PageEvents);

export class MixpanelService {
  private static instance: typeof mixpanel;

  get mixpanel(): typeof mixpanel {
    if (!MixpanelService.instance) {
      MixpanelService.instance = mixpanel;
    }

    return MixpanelService.instance;
  }

  constructor(superProperties?: SuperProperties) {
    if (!MixpanelService.instance) {
      this.mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
        debug: import.meta.env.MODE === 'development',
      });
    }

    superProperties && this.mixpanel.register(superProperties);
  }

  identifyUser(userId: ID): void {
    this.mixpanel.identify(userId);
  }

  setUserProperties(properties: Partial<UserProperties>): void {
    this.mixpanel.people.set(properties);
  }

  reset(): void {
    this.mixpanel.reset();
  }

  track<TrackEvent extends PageEvents | ActionEvents>(
    trackEvent: TrackEvent,
    eventInfo?: EventProps<TrackEvent>,
  ): void {
    if (pageEvents.includes(trackEvent as PageEvents)) {
      this.mixpanel.track('screen_view', {
        screen: trackEvent,
        ...(eventInfo ?? {}),
      });

      return;
    }

    this.mixpanel.track(trackEvent, eventInfo);
  }
}
